import { PricingTheme } from '~app/styles/pricing/types';
import { pricingElevation, packageColors, packageTheme } from '~app/styles/theme';
import { pricingPalette } from '~app/styles/pricing/colors';

import grow2792Theme from '~pricing/experiments/grow_2792_pnp_refresh_v1/theme';
import useExperimentAssignment from './useExperimentAssignment';

export default function useTheme(): PricingTheme {
  const pricingTheme: PricingTheme = {
    pricingElevation,
    pricingPalette, // User defined theme
    packageColors,
    packageTheme,
  };

  const { isPnPRefresh } = useExperimentAssignment();

  // GROW-2792 PnP Refresh
  if (isPnPRefresh) {
    return {
      ...pricingTheme,
      packageTheme: {
        ...packageTheme,
        ...grow2792Theme,
      },
    };
  }

  return pricingTheme;
}
